export default __webpack_public_path__ + "assets/38bfc573882a13cd65849d7c094d4ad3.svg";